export default {
    now: () =>
        JIX.Gettext.__('nuværende'),
    managementPosition: () =>
        JIX.Gettext.__('indeholder ledelseserfaring'),

    durationYears: (years) => JIX.Gettext.__nx('{years} år', '{years} år', years, { years }),
    durationMonths: (months) => JIX.Gettext.__nx('{months} md.', '{months} mdr.', months, { months }),
};
